import dayjs from 'dayjs';
export const botMessageType = 'bot';
export const selfMessageType = 'self';

export function createMessagePayload({
    userId,
    senderType,
    type,
    messageId,
    sourceMessageId,
    message,
    data,
    slots,date

}) {
    return {
        userId,
        senderType,
        type,
        messageId,
        sourceMessageId,
        message,
        data,
        slots,date
    }
}

export function createSelfMessagePayload(message, date, messageId) {
    return createMessagePayload({
        senderType: selfMessageType,
        type: message.type,
        messageId: "user",
        // The id the message was persisted under. Distinct from `messageId`,
        // which is a sender marker the renderer keys off - renaming that would
        // reach into every bot-message component. This is what the trace groups
        // are keyed by, so it is what lines a turn's spans up with its message.
        sourceMessageId: messageId,
        message: message.content,
        date: getMessageTime(date)
    })
}

export function createBotMessagePayload(message, date, messageId) {
    return createMessagePayload({
        senderType: botMessageType,
        type: message.type,
        messageId: "bot",
        sourceMessageId: messageId,
        message: message.content,
        date: getMessageTime(date)
    })
}

function getMessageTime(date) {
    try {
        return (dayjs(date) || dayjs()).format("hh:mm A");
    } catch (e) {
        console.error("getMessageTime failed", e);
        return date;
    }
}